import { useViewContext } from "@editor-providers";
import { useCallback, type MouseEvent } from "react";
import { getTabByAnchorInside } from "../utils";

export const useAnchorTrigger = () => {
  const { view } = useViewContext();
  const isEditor = view === "editor";
  const handleAnchorClick = useCallback(
    (event: MouseEvent, type?: string) => {
      const triggerElement: any = event.target;
      const currentTriggerElement: HTMLElement | null = triggerElement.closest(
        "[data-anchor-trigger]",
      );
      const currentTrigger = currentTriggerElement
        ? currentTriggerElement.getAttribute("data-anchor-trigger")
        : null;

      if (!currentTrigger) return;
      const anchorTargetElement = document.querySelector(
        '[data-anchor-target="' + currentTrigger + '"]',
      );

      if (!anchorTargetElement || (type && type !== "anchor")) return;

      if (!isEditor) {
        const tab = getTabByAnchorInside(anchorTargetElement);
        if (tab) {
          tab.click();
          setTimeout(() => {
            const tabsCombo = tab.closest('[data-combo-name="Tabs"]');
            (tabsCombo instanceof HTMLElement
              ? tabsCombo
              : anchorTargetElement
            ).scrollIntoView();
          });
          return;
        }

        const timelineItem = anchorTargetElement.closest(".timeline-item");
        if (timelineItem instanceof HTMLElement) {
          const timelineCombo = timelineItem.closest(
            '.timeline-combo[data-timeline-type="horizontal"]',
          );
          if (timelineCombo instanceof HTMLElement) {
            timelineCombo.scrollIntoView();
            timelineItem.click();
          }
          return;
        }

        anchorTargetElement.scrollIntoView();
      }
    },
    [isEditor],
  );

  return { handleAnchorClick };
};
